import { generateUUID } from '@grafana/data';
import { t } from '@grafana/i18n';
import { appEvents } from 'app/core/app_events';
import { type OptionsPaneCategoryDescriptor } from 'app/features/dashboard/components/PanelEditor/OptionsPaneCategoryDescriptor';
import { ShowConfirmModalEvent } from 'app/types/events';

import { type BulkActionElement } from '../scene/types/BulkActionElement';
import {
  type EditableDashboardElement,
  type EditableDashboardElementInfo,
} from '../scene/types/EditableDashboardElement';

export class MultiSelectedVizPanelsEditableElement implements EditableDashboardElement {
  public readonly isEditableDashboardElement = true;
  public readonly key: string;

  constructor(private _panels: BulkActionElement[]) {
    this.key = generateUUID();
  }

  public getEditableElementInfo(): EditableDashboardElementInfo {
    return { typeName: t('dashboard.sidebar.elements.panels', 'Panels'), icon: 'folder', instanceName: '' };
  }

  public useEditPaneOptions(): OptionsPaneCategoryDescriptor[] {
    return [];
  }

  public onConfirmDelete() {
    appEvents.publish(
      new ShowConfirmModalEvent({
        title: t('dashboard.sidebar.elements.multiple-panels', 'Multiple panels'),
        text: t(
          'dashboard.sidebar.elements.multiple-panels-delete-text',
          'Are you sure you want to delete these panels? All queries will be removed.'
        ),
        onConfirm: () => this.onDelete(),
      })
    );
  }

  public onDelete() {
    this._panels.forEach((panel) => {
      panel.onDelete();
    });
  }
}
